import React from 'react';
import Layout from '../components/Layout';
import Sidebar from '../components/Sidebar';
import Job from '../components/Job';
import Education from '../components/Education';
import Project from '../components/Project';

import config from '../../config';
const IndexPage = () => (
  <Layout>
    <Sidebar />
    <div className="container-fluid p-0">
      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="about"
      >
        <div className="w-100">
          <h1 className="text-center mb-2">
            {config.firstName}
            <span className="text-primary"> {config.lastName}</span>
          </h1>
          <div className="text-center subheading mb-5">
            <i className="fas fa-map-marker-alt"></i> {config.address}
          </div>
          <p className="lead mb-5">
            I am a Frontend developer with experience in <strong> Vue.js</strong> and
            <strong> React.js</strong> as Javascript frameworks to build layouts, backend knowledge in 
            <strong> Node.js</strong>, and <strong> Express</strong> to handle server related development, 
            database knowledge in <strong> PostgreSQL</strong> and <strong> MongoDB</strong> (NoSQL), 
            experience with Javascript's superset <strong> Typescript</strong>, to maximize coding level 
            and consistency and Git and Github to keep everything versionated. I also have a Bachelor's 
            degree in Business Administration, which helps me a lot to have business insights. 
          </p>
          <div className="social-icons">
            {config.socialLinks.map(social => {
              const { icon, url } = social;
              return (
                <a key={url} href={url}>
                  <i className={`fab ${icon}`}></i>
                </a>
              );
            })}
          </div>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex justify-content-center"
        id="experience"
      >
        <div className="w-100">
          <h2 className="mb-5">Experiences</h2>
          {
            config.experiences.map(({ title, company, date, description }) => (
              <Job
                title={title}
                company={company}
                date={date}
                description={description}
                key={`${title} ${company}`}
              />
            ))
          }
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="education"
      >
        <div className="w-100">
          <h2 className="mb-5">Education</h2>
          {
            config.education.map(({ institution, degree, date }) => (
              <Education
                institution={institution}
                degree={degree}
                date={date}
                key={`${institution} ${degree}`}
              />
            ))
          }
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="skills"
      >
        <div className="w-100">
          <h2 className="mb-5">Skills</h2>

          <div className="subheading mb-3">
            Programming Languages &amp; Tools
          </div>
          <ul className="list-inline dev-icons">
            {
              config.skills.map(skill => (
                <li key={skill.name} className="list-inline-item">
                  <i key={skill.name} className={skill.devicon}></i>
                </li>
              ))
            }
          </ul>

          <div className="subheading mb-3">Perks</div>
          <ul className="fa-ul mb-0 workflow">
            <li>
              <i className="fa-li fa fa-check"></i>
              Mobile-First design and responsive layouts;
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Cross Browser Support;
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Single Page Applications (SPA) and Progressive Web Apps (PWA);
            </li>
            <li>
              <i className="fa-li fa fa-check"></i>
              Team Work
            </li>
          </ul>
        </div>
      </section>

      <hr className="m-0" />

      <section
        className="p-3 p-lg-5"
        id="projects"
      >
        <h2 className="mb-5">Projects</h2>
        <div className="row">
          {
            config.projects.map(({name, preview, description, live, source, techs}) => (
              <Project
                name={name}
                description={description}
                live={live}
                preview={preview}
                source={source}
                techs={techs}
                key={name}
              />
            ))
          }
        </div>

      </section>

      <hr className="m-0" />

      <section
        className="resume-section p-3 p-lg-5 d-flex align-items-center"
        id="interests"
      >
        <div className="w-100">
          <h2 className="mb-5">Personal Interests</h2>
          <p className="description">
            Apart from being a developer, I enjoy spending time with my family and helping homeless
            animals from my neighborhood. In my free time, I love to play the guitar too and play
            videogames. I like to read a lot: technical books, comics, mangas, blogs, everything
            meaningful to me. Writing is something that I am doing a lot lately: I started my blog
            and I love to spend some time of my day writing technical posts about programming to
            beginners and professional developers. Oh, I almost forgot: When I'm not a developer I
            am a great cook, specialized in egg dishes!
          </p>
        </div>
      </section>

      <hr className="m-0" />
    </div>
  </Layout>
);

export default IndexPage;
